class Dashboard {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {{}}
         */
        this.gameData = {};
        /**
         * @type HTMLElement|null
         */
        this.uhPanel = null;
        /**
         * @type {NodeListOf<Element>}
         */
        this.donuts = document.querySelectorAll('.donut-container');
        /**
         * @type {Modal}
         */
        this.modalDeleteAccount = new Modal(document.getElementById('delete-account'));
        /**
         * _init
         */
        this._init();
    }

    /**
     * Init
     * @private
     */
    _init() {
        const CHECKBOX_ALERT  = document.getElementById('form-alert').querySelectorAll('input.checkbox');
        const PROGRESSIONS    = document.querySelectorAll('[data-tool]');
        this.uhPanel          = document.getElementById('uhpanel');
        this._formProgression = document.getElementById('form-engagement');

        // Listener
        document.getElementById('charts-accordion').addEventListener('click', (e) => {
            if (this.uhPanel.style.maxHeight === '' && !this.uhPanelVisible) {
                this._getGameData();
            }
        });
        document.getElementById('delete-account').addEventListener('click', () => this._deleteAccount());
        document.getElementById('save-engagement').addEventListener('click', () => this._saveEngagement());
        document.getElementById('cancel-delete-account').addEventListener('click', () => this._cancelDeleteAccount());
        document.getElementById('confirm-delete-account').addEventListener('click', () => Dashboard._confirmDeleteAccount());
        for (let i = 0; i < CHECKBOX_ALERT.length; i++) {
            CHECKBOX_ALERT[i].addEventListener('click', () => this._toggleAlert(CHECKBOX_ALERT[i]));
        }

        for (let i = 0; i < PROGRESSIONS.length; i++) {
            const PROGRESSION = PROGRESSIONS[i];
            PROGRESSION.addEventListener('click', () => {
                this._progressionClick(PROGRESSION);
            });
        }

        WebFont.load({
            google: {
                families: ['Open Sans:300i,400,600,600i,700'],
            },
            active: function () {
                new DashboardCheckBoxOutput();
            }
        });
    }

    _progressionClick(input) {
        const TOOL_LINK = DashboardCheckBoxOutput.getLinkToTool(input);

        if (input.checked) {
            TOOL_LINK.classList.add('show');
        } else {
            TOOL_LINK.classList.remove('show');
        }

        const HTTP = new Http();

        setTimeout(() => {
            HTTP.ajax({
                url: `/profile`,
                type: 'POST',
                formData: new FormData(this._formProgression)
            }).then(() => {
                // Nothing
            })
        }, 100);
    }

    _toggleAlert(input) {
        const HTTP = new Http();
        
        HTTP.ajax({
            url: `/toolbox/subscription/${input.value}`,
            type: 'POST'
        }).then(() => {
            // Nothing
        })
    }

    /**
     * Save engagement
     * @private
     */
    _saveEngagement() {
        const FORM_DATA = new FormData(document.getElementById('form-engagement'));
        const HTTP      = new Http();

        HTTP.ajax({
            url: '/profile',
            formData: FORM_DATA,
            type: 'POST'
        }).then(() => {
            location.reload();
        })
    }

    /**
     * Delete account
     * @private
     */
    _deleteAccount() {
        this.modalDeleteAccount.open();
    }

    /**
     * Cancel delete account
     * @private
     */
    _cancelDeleteAccount() {
        this.modalDeleteAccount.close();
    }

    /**
     * Confirm delete account
     * @private
     */
    static _confirmDeleteAccount() {
        window.location.href = '/unsubscribe';
    }

    /**
     * Get game data
     * @private
     */
    _getGameData() {
        // Get game data
        GameAsync.get().then((response) => {
            this.gameData = JSON.parse(response);
            this._onDataReady();
        }).catch((e) => {
            console.log(e);
        });
    }

    /**
     * On data ready
     * @private
     */
    _onDataReady() {

        // Browse game
        for (let i = 0; i < 6; i++) {
            const PERCENT = (this.gameData[i + 1] && this.gameData[i + 1].scorePercent) ? this.gameData[i + 1].scorePercent : 0;
            // Set donut top percent
            new Donut(this.donuts[i], PERCENT);
        }

        // Set donut total percent
        document.getElementsByClassName('full-percent')[0].textContent = this.gameData.all.scorePercent;

        // Set commentary
        let titlePrimary   = '';
        let titleSecondary = '';

        if (this.gameData.all.scorePercent >= 75) {
            titlePrimary   = 'Excellent,';
            titleSecondary = ' et si vous témoigniez ?';
        } else if (this.gameData.all.scorePercent >= 60) {
            titlePrimary   = 'Un engagement de qualité,';
            titleSecondary = 'en route vers l’excellence';
        } else if (this.gameData.all.scorePercent >= 30) {
            titlePrimary   = 'Une démarche en cours de construction,';
            titleSecondary = 'on vous donne un coup de pouce...';
        } else {
            titlePrimary   = 'Lancez-vous';
            titleSecondary = 'et découvrez les actions à mettre en place !';
        }

        document.getElementById('primary-title').innerText   = titlePrimary;
        document.getElementById('secondary-title').innerText = titleSecondary;

        // -----------------------------------
        // User history
        // -----------------------------------

        const data = this.gameData.all.history;

        // Method to convert a color from hex to rgba

        function convertHex(hex, opacity) {

            hex = hex.replace('#', '');

            let r = parseInt(hex.substring(0, 2), 16);
            let g = parseInt(hex.substring(2, 4), 16);
            let b = parseInt(hex.substring(4, 6), 16);

            return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';

        }

        // Date format switcher

        const reverseDate = date => {

            let parts = date.split('/');

            return `${parts[2]}/${parts[1]}/${parts[0]}`;

        };

        // Initialize the chart

        const chart = new CanvasJS.Chart('user-chart', {

            width: 800,
            height: 400,

            title: {

                text: 'Evolution du score RSO',
                fontColor: '#0a2b5c',
                fontSize: 28,
                fontWeight: 'normal',
                fontFamily: 'Open Sans',
                margin: 20

            },

            axisX: {

                title: '',
                labelAngle: -45,
                labelFontSize: 14,
                labelFontColor: '#0A2B5C',
                labelFontWeight: 'bold',
                lineThickness: 0,
                tickLength: 20,
                tickColor: '#0A2B5C',
                interval: 1,

            },

            axisY: {

                gridThickness: 1,
                gridColor: "#E0E0E0",
                title: '',
                suffix: '%',
                maximum: 105,
                interval: 10,
                labelFontSize: 18,
                labelFontColor: '#0A2B5C',
                labelFontWeight: 'bold',
                lineThickness: 0,
                tickLength: 15,
                tickColor: '#ffffff',
                minimum: -9,
                includeZero: false,

            },

            toolTip: {

                contentFormatter: function (e) {

                    return e.entries[0].dataPoint.category + '<br>Le ' + e.entries[0].dataPoint.date + ' vous aviez ' + e.entries[0].dataPoint.y + '% de réussite.';

                }

            },

            data: []

        });

        // Set the chart data

        Object.keys(data.categories).forEach(function (category) {

            let dates = Object.keys(data.categories[category]).map(reverseDate).sort().map(reverseDate);
            let dps   = [];
            let dte   = 0;

            Object.keys(dates).map(function (e) {

                dps.push({
                    y: Math.round(data.categories[category][dates[e]]['data']['percent']),
                    date: dates[e],
                    label: dates[e].replace(/^(\d{2})\/(\d{2})\/(\d{4})$/g, "$2/$3"),
                    category: category
                });
                dte = dates[e];

            });

            // Resets the array if it contains only one entry

            if (dps.length === 1) {

                document.getElementById('user-message').style.display = 'block';

                dps = [];

            }

            // Push the data

            chart.options.data.push({

                type: 'line',
                color: convertHex(data.categories[category][dte]['bkg'], 40),
                dataPoints: dps

            });

        });

        // Set the chart score

        let dates = Object.keys(data.score).map(reverseDate).sort().map(reverseDate);
        let dps   = [];

        Object.keys(dates).map(function (e) {

            dps.push({
                y: Math.round(data.score[dates[e]]['percent']),
                date: dates[e],
                label: dates[e],
                category: 'Score global RSO'
            });

        });

        // Resets the array if it contains only one entry

        if (dps.length === 1) {

            document.getElementById('user-message').style.display = 'block';

            dps = [];

        }

        // Push the data

        chart.options.data.push({

            type: 'line',
            lineDashType: 'dash',
            color: 'red',
            dataPoints: dps

        });

        // Update the accordion panel
        this.uhPanel.style.maxHeight = '2000px';

        // Draw the chart
        chart.render();

    }

}
